<template>
    <storefront-node :storefront-prefix="storefrontPrefix" />
</template>

<script setup lang="ts">
import { definePageMeta } from '#imports'
import StorefrontNode from '~/components/Storefront/StorefrontNode.vue'
import { inject } from 'vue'

// Catalog nodes expose public offerings, calendars, and catalog content.
definePageMeta({ searchIndexing: 'public' })

const storefrontPrefix = inject('STOREFRONT_PREFIX')
</script>
